import CityPageTemplate from "../city-template/CityPageTemplate";
import { salisburyMdConfig } from "./data";

export default function SalisburyMdPage() {
  return <CityPageTemplate config={salisburyMdConfig} />;
}